export const PROGRAMS_STATUS = {
  PAST: {
    label: 'Past',
    value: 'PAST',
    number: 1,
  },
  CURRENT: {
    label: 'Current',
    value: 'CURRENT',
    number: 2,
  },
  FUTURE: {
    label: 'Future',
    value: 'FUTURE',
    number: 3,
  },
  NO_SESSIONS: {
    label: 'No Sessions',
    value: 'no-sessions',
    number: 4,
  },
  CANCELED: {
    label: 'Canceled',
    value: 'CANCELED',
    number: 5,
  },
}